const contextKeys = {
  projectConsentsListContextKey: 'consent-project-consents',
  consentFormsListContextKey: 'consent-forms',
  groupListContextKey: 'consent-groups',
  fetchUserConsent: 'consent-fetch-user-consent',
  fetchConsentQuestionnaire: 'consent-detail-fetch-questionnaire',
  fetchConsentQuestionnaireResponse:
    'consent-detail-fetch-questionnaireResponse',
  rootGroupQuery: 'rootGroupQuery',
};

export default contextKeys;
